import { Component, Input, OnInit, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';

// Declare adsbygoogle for TypeScript
declare global {
    interface Window {
        adsbygoogle: any[];
    }
}

@Component({
    selector: 'app-web-ad',
    template: `
    <div *ngIf="!isNative" class="web-ad-container">
      <div class="ad-wrap">
        <ins class="adsbygoogle"
             style="display:block"
             data-ad-format="fluid"
             data-ad-layout-key="-eb+6l-2v-aq+u1"
             data-ad-client="ca-pub-4064804885712348"
             [attr.data-ad-slot]="adSlot"></ins>
        <div class="ad-label">Ad</div>
      </div>
    </div>
  `,
    styles: [`
    .ad-wrap { 
      margin: 8px 0 12px; 
      position: relative; 
      width: 100%; 
      min-width: 300px;
      display: block; 
      overflow: hidden; 
      background: #f8f9fa; 
      border: 1px solid #e9ecef; 
      border-radius: 8px; 
    }
    .ad-label {
      position: absolute; 
      top: 4px; 
      left: 8px;
      font-size: 11px; 
      opacity: .7; 
      text-transform: uppercase;
      pointer-events: none;
      z-index: 1;
    }
    ins.adsbygoogle {
      display: block !important;
      width: 100% !important;
      min-width: 300px !important;
    }
  `]
})
export class WebAdComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() adUnitId: string = '';
    @Input() adSlot: string = '';

    isNative = Capacitor.isNativePlatform();
    private pushed = false;

    constructor(
        private el: ElementRef
    ) { }

    ngOnInit(): void {
        // Component initialization - no complex logic needed
    }

    ngAfterViewInit(): void {
        if (!this.isNative && this.adSlot) {
            console.log('WebAdComponent: Initializing for slot:', this.adSlot);
            console.log('WebAdComponent: adsbygoogle available:', !!window.adsbygoogle);
            console.log('WebAdComponent: AdSense script loaded:', !!document.querySelector('script[src*="pagead2.googlesyndication.com"]'));

            // Load ad immediately instead of waiting for intersection
            setTimeout(() => {
                console.log('WebAdComponent: Loading ad immediately for slot:', this.adSlot);
                this.pushOnce();
            }, 1000); // Give the service time to load the script
        }
    }

    ngOnDestroy(): void {
        // Cleanup if needed
    }

    private pushOnce() {
        if (this.pushed) return;
        this.pushed = true;

        // Guard: if AdSense already marked the element, skip
        const ins: HTMLElement | null = this.el.nativeElement.querySelector('ins.adsbygoogle');
        if (ins && ins.getAttribute('data-adsbygoogle-status') === 'done') {
            console.log('AdSense: Ad already loaded for slot:', this.adSlot);
            return;
        }

        // Check if adsbygoogle is available
        if (!window.adsbygoogle) {
            console.warn('AdSense: adsbygoogle not available, retrying...');
            this.pushed = false;
            setTimeout(() => this.pushOnce(), 1000);
            return;
        }

        try {
            console.log('WebAdComponent: About to push ad for slot:', this.adSlot);
            console.log('WebAdComponent: adsbygoogle array length before push:', window.adsbygoogle.length);
            window.adsbygoogle.push({});
            console.log('WebAdComponent: adsbygoogle array length after push:', window.adsbygoogle.length);
            console.log('AdSense: Successfully pushed ad for slot:', this.adSlot);
        } catch (err) {
            // Check if it's the "already have ads" error - this is expected and safe to ignore
            const errorMessage = err?.toString() || '';
            if (errorMessage.includes('already have ads in them')) {
                console.log('AdSense: Ad already loaded for slot:', this.adSlot, '(this is normal)');
                return; // Don't retry for this expected error
            }

            // For other errors, reset and retry once
            this.pushed = false;
            console.warn('AdSense: Unexpected error during push, retrying once:', err);
            setTimeout(() => {
                if (!this.pushed) {
                    this.pushOnce();
                }
            }, 1000);
        }
    }
}